import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { Text, View } from 'react-native';

export const DefectiveLabel = memo(
  ({ color, text }: { color: string; text: string }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        css={`
          background-color: ${color};
          height: ${rpx(16)}px;
          border-radius: ${rpx(8)}px;
          align-items: center;
          justify-content: center;
          width: ${rpx(38)}px;
        `}
      >
        <Text
          css={`
            font-family: ${FontFamily.NotoSans.Light};
            font-size: ${rpx(10)}px;
            line-height: ${rpx(16)}px;
            text-align: center;
            color: #fff;
          `}
        >
          {text}
        </Text>
      </View>
    );
  },
);
